// extracted by mini-css-extract-plugin
export var arrow = "GlobalMessage-module--arrow--a2f6b";
export var arrowNo = "GlobalMessage-module--arrow_no--d24f3";
export var arrowYes = "GlobalMessage-module--arrow_yes--0c08b";
export var error = "GlobalMessage-module--error--9cbd5";
export var flex = "GlobalMessage-module--flex--bd1fa";
export var flex1 = "GlobalMessage-module--flex_1--b271a";
export var flexCenter = "GlobalMessage-module--flex_center--c9fe2";
export var flexCenterCol = "GlobalMessage-module--flex_center_col--4ba0c";
export var flexCol = "GlobalMessage-module--flex_col--f7ba7";
export var flexFixCenterCol = "GlobalMessage-module--flex_fix_center_col--48b34";
export var flexFixedCenterCol = "GlobalMessage-module--flex_fixed_center_col--8d1a1";
export var neutral = "GlobalMessage-module--neutral--95f6b";
export var positive = "GlobalMessage-module--positive--315ba";
export var rotating = "GlobalMessage-module--rotating--bb200";
export var wrapper = "GlobalMessage-module--wrapper--31047";